export default __webpack_public_path__ + "static/media/25-percent.49db7d3f.gif";